<template>
  <div class="form-section">
    <div class="d-flex mb-large" style="align-items: center">
      <div style="flex: 1"></div>
      <b-button class="ml-large" variant="outline-primary" size="sm" @click="openFeatureCreator">
        <i class="fas fa-plus-circle"></i> new feature enabled
      </b-button>
    </div>

    <b-table :items="features" :fields="tableFields" :no-local-sorting="true">
      <template #cell(createdAt)="row">
        <span> {{row.item.createdAt | luxon({ output: { format: "yyyy-MM-dd" } })}}</span>
      </template>

      <template #cell(actions)="row">
        <b-button variant="secondary" class="btn-small mr-standard" @click="openFeatureEditor(row.item)">
          <i class="fas fa-pen"></i>
        </b-button>
        <b-button variant="secondary" class="btn-small mr-standard" @click="showDeleteFeatureConfirmation(row.item)">
          <i class="fas fa-trash"></i>
        </b-button>
      </template>
    </b-table>

    <div style="text-align: center;height: 130px; padding-top: 40px" v-if="features.length === 0">No Data</div>

    <modal-feature-enabled-editor ref="modalEnabledEditorRef" :on-success="onEditedFeature"></modal-feature-enabled-editor>
    <modal-feature-enabled-delete ref="modalEnabledDeleteRef" :on-success="onEditedFeature"></modal-feature-enabled-delete>
  </div>
</template>
<script>
  import ModalFeatureEnabledEditor from "./ModalFeatureEnabledEditor";
  import ModalFeatureEnabledDelete from "./ModalFeatureEnabledDelete";
  import axios from 'axios';

  export default {
    components: {ModalFeatureEnabledEditor, ModalFeatureEnabledDelete},
    data() {
      return {
        features: [],
        tableFields: [
          {key: 'name', label: 'Name', sortable: false},
          {key: 'description', label: 'Description', sortable: false},
          {key: 'actions', label: 'Actions'}
        ]
      };
    },
    created() {
      this.fetchAllFeatures();
    },
    methods: {
      fetchAllFeatures() {
        axios.get(`/api/mockConfig/feature`)
          .then(response => {
            this.features = response.data;
          })
          .catch(e => {
            this.$onError(e);
          })
      },
      onEditedFeature() {
        this.$bus.emit('enabler:edited');
        this.fetchAllFeatures()
      },
      openFeatureCreator() {
        this.$refs.modalEnabledEditorRef.showModal();
      },
      openFeatureEditor(feature) {
        this.$refs.modalEnabledEditorRef.showModal(feature.id);
      },
      showDeleteFeatureConfirmation(feature) {
        this.$refs.modalEnabledDeleteRef.showModal(feature);
      },
    }
  };
</script>
